export enum MESSAGE_TYPES {
  TEXT = "text",
  FILE = "file",
  BUTTONS = "buttons",
  SERVICE = "service",
}
